import { IonModal, IonButton, IonText, IonIcon, IonImg, IonSegment, IonSegmentButton, IonLabel } from '@ionic/react';
import { airplane, close } from 'ionicons/icons';
import { useState } from 'react';
import './FlightDetails.css';
import { Constants } from '../../../defines/Constants';
import { FormatTime, FormatDate, Durational, BaggareFormat, NumberToAlpha } from '../../../defines/Functions';

interface Props {
    data: any,
    flightDefines: any,
    searchType: string
}
const FlightDetails = (item: Props) => {
    const [state, setState] = useState({
        showFlightDetailsModal: false,
        segValue: 'index0'
    });
    return (
        <>
            <IonModal isOpen={state.showFlightDetailsModal} onDidDismiss={() => setState({ ...state, showFlightDetailsModal: false })} mode="ios" cssClass="flight-details-modal">
                <div className="flight-details-modal-content">
                    <h3 className="flight-details-modal-title">
                        جزئیات پرواز
                        <IonIcon icon={close} onClick={() => setState({ ...state, showFlightDetailsModal: false })} />
                    </h3>
                    {item.searchType === 'roundtrip' ?
                        <div className="flight-details-modal-tabs">
                            <IonSegment value={state.segValue} onIonChange={e => setState({ ...state, segValue: e.detail.value! })} mode="md">
                                <IonSegmentButton value="index0">
                                    <IonLabel>رفت</IonLabel>
                                </IonSegmentButton>
                                <IonSegmentButton value="index1">
                                    <IonLabel>برگشت</IonLabel>
                                </IonSegmentButton>
                            </IonSegment>
                        </div>
                        : item.searchType === 'multiple' ?
                            <div className="flight-details-modal-tabs">
                                <IonSegment value={state.segValue} onIonChange={e => setState({ ...state, segValue: e.detail.value! })} mode="md">
                                    {item.data.airItinerary.originDestinationOptions.originDestinationOption.map((originDestination: any, index: number) =>
                                        <IonSegmentButton value={"index" + index} key={"index" + index}>
                                            <IonLabel>مسیر {NumberToAlpha(index + 1)}</IonLabel>
                                        </IonSegmentButton>
                                    )}
                                </IonSegment>
                            </div>
                            :
                            null
                    }
                    {item.data.airItinerary.originDestinationOptions.originDestinationOption.map((originDestination: any, index: number) =>
                        <div key={'index' + index}>
                            {state.segValue === 'index' + index &&
                                <>
                                    <h5 className="flight-details-modal-info">
                                        {item.searchType === 'roundtrip' ?
                                            state.segValue === 'index0' ? 'پرواز رفت' : 'پرواز برگشت'
                                            : item.searchType === 'multiple' ?
                                                'مسیر ' + NumberToAlpha(index + 1)
                                                :
                                                null
                                        }
                                        <span>
                                            {originDestination.flightSegment.length === 1 ? (
                                                'بدون توقف'
                                            ) : (
                                                originDestination.flightSegment.length - 1 + ' توقف'
                                            )}
                                        </span>
                                    </h5>
                                    {originDestination.flightSegment.map((segment: any, indexSegment: number) =>
                                        <div className="flight-details-modal-items" key={indexSegment}>
                                            <div className="column column-1">
                                                <span>
                                                    {segment.tpaextensions.any[0].departureCityPersian ? (
                                                        segment.tpaextensions.any[0].departureCityPersian
                                                    ) : (
                                                        segment.tpaextensions.any[0].departureCity
                                                    )}
                                                </span>
                                                <span className="grey">
                                                    {segment.tpaextensions.any[0].departureAirportPersian ? (
                                                        segment.tpaextensions.any[0].departureAirportPersian
                                                    ) : (
                                                        segment.tpaextensions.any[0].departureAirport
                                                    )}
                                                </span>
                                                <IonImg src={Constants.airlines + segment.operatingAirline.code + '.png'} />
                                                <span className="grey">
                                                    {segment.tpaextensions.any[0].airlinePersian ? (
                                                        segment.tpaextensions.any[0].airlinePersian
                                                    ) : (
                                                        segment.operatingAirline.companyShortName
                                                    )}
                                                </span>
                                                <span>
                                                    {segment.tpaextensions.any[0].arrivalCityPersian ? (
                                                        segment.tpaextensions.any[0].arrivalCityPersian
                                                    ) : (
                                                        segment.tpaextensions.any[0].arrivalCity
                                                    )}
                                                </span>
                                                <span className="grey">
                                                    {segment.tpaextensions.any[0].arrivalAirportPersian ? (
                                                        segment.tpaextensions.any[0].arrivalAirportPersian
                                                    ) : (
                                                        segment.operatingAirline.arrivalAirport
                                                    )}
                                                </span>
                                            </div>
                                            <div className="column column-2">
                                                <IonIcon icon={airplane} />
                                                <span></span>
                                                <IonIcon icon={airplane} />
                                            </div>
                                            <div className="column column-3">
                                                <span>
                                                    {FormatTime(segment.departureDateTime, "hh:mm")}
                                                </span>
                                                <span className="grey flight-details-datetime">
                                                    {item.flightDefines.targetName === 'Domestic' ?
                                                        FormatDate(segment.departureDateTime, 'dddd jD jMMMM jYYYY')
                                                        :
                                                        <>
                                                            <span>{FormatDate(segment.departureDateTime, 'dddd jD jMMMM jYYYY')}</span>
                                                            <span className="flight-details-datetime-en">
                                                                {FormatDate(segment.departureDateTime, 'dddd D MMMM YYYY', 'en')}
                                                            </span>
                                                        </>
                                                    }
                                                </span>
                                                <span className="grey">
                                                    کلاس پرواز:
                                                    <b> {item.flightDefines.cabinClass}</b>
                                                </span>
                                                <span className="grey">
                                                    شماره پرواز:
                                                    <b> {segment.flightNumber}</b>
                                                </span>
                                                {segment.tpaextensions.any[0].aircraftName ?
                                                    <span className="grey">
                                                        نوع هواپیما:
                                                        <b> {segment.tpaextensions.any[0].aircraftName}</b>
                                                    </span>
                                                    :
                                                    null
                                                }
                                                <span className="grey">
                                                    مدت زمان پرواز:
                                                    <b> {Durational(segment.departureDateTime, segment.arrivalDateTime)}</b>
                                                </span>
                                                <span className="grey">
                                                    میزان بار مجاز:
                                                    <b> {BaggareFormat(segment.tpaextensions.any[0].freeBaggage)}</b>
                                                </span>
                                                <span>
                                                    {FormatTime(segment.arrivalDateTime, "hh:mm")}
                                                </span>
                                                <span className="grey flight-details-datetime">
                                                    {item.flightDefines.targetName === 'Domestic' ?
                                                        FormatDate(segment.departureDateTime, 'dddd jD jMMMM jYYYY')
                                                        :
                                                        <>
                                                            <span>{FormatDate(segment.departureDateTime, 'dddd jD jMMMM jYYYY')}</span>
                                                            <span className="flight-details-datetime-en">
                                                                {FormatDate(segment.departureDateTime, 'dddd D MMMM YYYY', 'en')}
                                                            </span>
                                                        </>
                                                    }
                                                </span>
                                            </div>
                                            {item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[1 + indexSegment] !== undefined &&
                                                Durational(segment.arrivalDateTime, item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[1 + indexSegment].departureDateTime) !== 0 &&
                                                <div className="flight-details-stop">
                                                    {item.data.airItinerary.originDestinationOptions.originDestinationOption[index].flightSegment[1 + indexSegment] !== undefined &&
                                                        <div>
                                                            <span> مدت زمان توقف </span>
                                                            {item.data.airItinerary.originDestinationOptions.originDestinationOption[index].flightSegment[1 + indexSegment].tpaextensions.any[0].departureCityPersian &&
                                                                <span>
                                                                    <span> در </span>
                                                                    {item.data.airItinerary.originDestinationOptions.originDestinationOption[index].flightSegment[1 + indexSegment].tpaextensions.any[0].departureCityPersian}
                                                                </span>

                                                            }
                                                            {!item.data.airItinerary.originDestinationOptions.originDestinationOption[index].flightSegment[1 + indexSegment].tpaextensions.any[0].departureCityPersian &&
                                                                <span>
                                                                    <span> در </span>
                                                                    {item.data.airItinerary.originDestinationOptions.originDestinationOption[index].flightSegment[1 + indexSegment].tpaextensions.any[0].departureCity}
                                                                </span>
                                                            }
                                                        </div>
                                                    }
                                                    <span>
                                                        {Durational(item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[indexSegment].arrivalDateTime, item.data.airItinerary.originDestinationOptions.originDestinationOption[0].flightSegment[1 + indexSegment].departureDateTime)}
                                                    </span>
                                                </div>
                                            }
                                        </div>
                                    )}
                                </>
                            }
                        </div>
                    )}
                </div>
                <div>
                    <IonButton color="warning" expand="block" onClick={() => setState({ ...state, showFlightDetailsModal: false })} className="flight-details-modal-close-btn">بستن</IonButton>
                </div>
            </IonModal>
            <IonText className="flight-details-label" onClick={() => setState({ ...state, showFlightDetailsModal: true })}>جزئیات پرواز</IonText>
        </>
    );
};
export default FlightDetails;